import React from "react";
import Login from "./Login";

export default function AdminLogin() {
  return <Login adminMode={true} />;
}
